/* portraet-widget.js – AI-portræt på produktsiden (vores egen motor i stedet for Autopictura).
   Indsættes i produktformularen:  <div class="pw" data-api="https://..." data-emne="baby"></div>
   Kunden vælger stil, uploader et foto og vælger ét af portrætterne. Valget lægges på kurvlinjen som
   properties[_portraet_id] (bruges af ordre-automatikken til trykfilen), Portræt (link til forhåndsvisningen), Stil og tekstfelterne.
   "Læg i kurv" er spærret, indtil et portræt er valgt. */
(function () {
  'use strict';

  var VENT = ['Kigger grundigt på billedet …', 'Finder penslerne frem …', 'Tegner de første streger …',
    'Lægger de fine detaljer …', 'Næsten færdig …', 'Det tager lidt længere tid end normalt …'];
  var GEM = 'pw-portraetter-';

  function el(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }
  function gemt(emne) {
    try { return JSON.parse(localStorage.getItem(GEM + emne)) || []; } catch (e) { return []; }
  }
  function gem(emne, liste) {
    try { localStorage.setItem(GEM + emne, JSON.stringify(liste.slice(0, 8))); } catch (e) { /* privat vindue: ikke vigtigt */ }
  }

  // Skalér fotoet ned i browseren (hurtigere upload, og billedet drejes rigtigt efter EXIF)
  function skalerFoto(fil) {
    return new Promise(function (ok, nej) {
      if (!/^image\//.test(fil.type)) { nej(new Error('Vælg et billede (JPEG eller PNG).')); return; }
      var url = URL.createObjectURL(fil), img = new Image();
      img.onload = function () {
        var maks = 1536, s = Math.min(1, maks / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * s); c.height = Math.round(img.naturalHeight * s);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        if (Math.min(img.naturalWidth, img.naturalHeight) < 400) { nej(new Error('Billedet er for lille. Brug et foto på mindst 400 × 400 pixels.')); return; }
        ok(c.toDataURL('image/jpeg', 0.88));
      };
      img.onerror = function () { URL.revokeObjectURL(url); nej(new Error('Billedet kunne ikke læses. Brug JPEG eller PNG.')); };
      img.src = url;
    });
  }

  function init(root) {
    var api = (root.getAttribute('data-api') || '').replace(/\/$/, '');
    var emneId = root.getAttribute('data-emne');
    var form = root.closest('form') || document.querySelector('form[action*="/cart/add"]');
    var s = { cfg: null, stil: null, foto: null, valgt: null, travl: false, liste: gemt(emneId) };
    var ui = {};

    root.classList.add('pw--indlaeser');
    root.textContent = 'Indlæser portrætværktøjet …';
    fetch(api + '/api/emne?emne=' + encodeURIComponent(emneId))
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (cfg) { s.cfg = cfg; tegn(); })
      .catch(function () { root.textContent = 'Portrætværktøjet kunne ikke indlæses. Genindlæs siden, eller skriv til os.'; });

    function trin(nr, tekst) {
      var h = el('div', 'pw__trin');
      h.appendChild(el('span', 'pw__nr', String(nr)));
      h.appendChild(el('span', null, tekst));
      return h;
    }

    function tegn() {
      var cfg = s.cfg, nr = 1;
      root.classList.remove('pw--indlaeser');
      root.textContent = '';

      // 1) Stil
      root.appendChild(trin(nr++, 'Vælg stil'));
      ui.stilarter = el('div', 'pw__stilarter');
      ui.stilarter.setAttribute('role', 'radiogroup');
      cfg.stilarter.forEach(function (st, i) {
        var b = el('button', 'pw__stil');
        b.type = 'button';
        b.setAttribute('role', 'radio');
        b.appendChild(el('strong', null, st.navn));
        b.appendChild(el('span', null, st.beskrivelse));
        b.addEventListener('click', function () { vaelgStil(st.id); });
        b.dataset.id = st.id;
        ui.stilarter.appendChild(b);
        if (i === 0) s.stil = st.id;
      });
      root.appendChild(ui.stilarter);

      // 2) Foto
      root.appendChild(trin(nr++, cfg.upload_tekst || 'Upload et foto'));
      ui.upload = el('label', 'pw__upload');
      ui.fil = el('input');
      ui.fil.type = 'file'; ui.fil.accept = 'image/*';
      ui.uploadTekst = el('span', 'pw__upload-tekst', 'Klik her, eller træk et foto hertil');
      ui.thumb = el('img', 'pw__thumb'); ui.thumb.alt = ''; ui.thumb.hidden = true;
      ui.upload.appendChild(ui.fil); ui.upload.appendChild(ui.thumb); ui.upload.appendChild(ui.uploadTekst);
      root.appendChild(ui.upload);
      if (cfg.tip) root.appendChild(el('p', 'pw__tip', cfg.tip));
      if (cfg.privatliv) root.appendChild(el('p', 'pw__tip', cfg.privatliv));
      ui.fil.addEventListener('change', function () { if (ui.fil.files[0]) laesFoto(ui.fil.files[0]); });
      ['dragenter', 'dragover'].forEach(function (t) { ui.upload.addEventListener(t, function (e) { e.preventDefault(); ui.upload.classList.add('pw__upload--over'); }); });
      ['dragleave', 'drop'].forEach(function (t) { ui.upload.addEventListener(t, function (e) { e.preventDefault(); ui.upload.classList.remove('pw__upload--over'); }); });
      ui.upload.addEventListener('drop', function (e) { var f = e.dataTransfer.files[0]; if (f) laesFoto(f); });

      // 3) Tekst (valgfri)
      ui.felter = {};
      if (cfg.felter && cfg.felter.length) {
        root.appendChild(trin(nr++, 'Tekst på plakaten (valgfri)'));
        var g = el('div', 'pw__felter');
        cfg.felter.forEach(function (f) {
          var l = el('label', 'pw__felt');
          l.appendChild(el('span', null, f.label));
          var inp = el('input');
          inp.type = 'text'; inp.maxLength = f.maks; inp.placeholder = f.placeholder || ''; inp.autocomplete = 'off';
          l.appendChild(inp);
          g.appendChild(l);
          ui.felter[f.id] = inp;
        });
        root.appendChild(g);
        root.appendChild(el('p', 'pw__tip', 'Tjek stavningen i forhåndsvisningen. Vi trykker teksten præcis, som den står.'));
      }

      ui.lav = el('button', 'pw__lav', 'Lav mit portræt');
      ui.lav.type = 'button';
      ui.lav.addEventListener('click', lav);
      root.appendChild(ui.lav);
      ui.status = el('p', 'pw__status');
      ui.status.setAttribute('aria-live', 'polite');
      root.appendChild(ui.status);

      ui.resultater = el('div', 'pw__resultater');
      root.appendChild(ui.resultater);
      ui.info = el('p', 'pw__info', 'Forhåndsvisningen har vandmærke. Din plakat bliver trykt uden vandmærke.');
      ui.info.hidden = true;
      root.appendChild(ui.info);

      // Felter i produktformularen, som Shopify lægger på kurvlinjen. De lægges direkte i formularen, når widgetten
      // står uden for den: form="..." virker ikke i Horizon, hvor feltet name="id" skygger for form.id.
      ui.skjult = {};
      var holder = form && !form.contains(root) ? form : root;
      ['_portraet_id', 'Portræt', 'Stil'].concat(cfg.felter.map(function (f) { return f.egenskab; })).forEach(function (navn) {
        var inp = el('input');
        inp.type = 'hidden'; inp.name = 'properties[' + navn + ']'; inp.disabled = true;
        holder.appendChild(inp);
        ui.skjult[navn] = inp;
      });

      vaelgStil(s.stil);
      s.liste.forEach(function (gen) { visGen(gen, false); });
      opdater();
    }

    function vaelgStil(id) {
      s.stil = id;
      Array.prototype.forEach.call(ui.stilarter.children, function (b) {
        var on = b.dataset.id === id;
        b.classList.toggle('pw__stil--valgt', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    function laesFoto(fil) {
      status('');
      skalerFoto(fil).then(function (data) {
        s.foto = data;
        ui.thumb.src = data; ui.thumb.hidden = false;
        ui.uploadTekst.textContent = 'Skift foto';
        ui.upload.classList.add('pw__upload--har');
        opdater();
      }, function (e) { status(e.message, true); });
    }

    function status(t, fejl) {
      ui.status.textContent = t;
      ui.status.classList.toggle('pw__status--fejl', !!fejl);
    }

    function opdater() {
      ui.lav.disabled = s.travl || !s.foto || !s.stil;
      ui.lav.textContent = s.travl ? 'Laver dit portræt …' : (s.liste.length ? 'Lav nye portrætter' : 'Lav mit portræt');
      ui.info.hidden = !s.liste.length;
    }

    function lav() {
      if (s.travl || !s.foto) return;
      var felter = {};
      Object.keys(ui.felter).forEach(function (k) { felter[k] = ui.felter[k].value.trim(); });
      s.travl = true; opdater();
      var i = 0;
      status(VENT[0]);
      var timer = setInterval(function () { i = Math.min(i + 1, VENT.length - 1); status(VENT[i]); }, 7000);
      root.classList.add('pw--travl');
      fetch(api + '/api/portraet', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ emne: emneId, stil: s.stil, foto: s.foto, felter: felter })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (!r.ok) throw new Error(d.fejl || 'Noget gik galt. Prøv igen.');
          return d;
        });
      }).then(function (d) {
        var gen = { id: d.id, stil: d.stil, felter: d.felter, billeder: d.billeder.map(function (b) { return { id: b.id, url: absolut(b.url) }; }) };
        s.liste.unshift(gen); gem(emneId, s.liste);
        visGen(gen, true);
        status(d.tilbage != null && d.tilbage < 6 ? 'Vælg dit yndlingsportræt. Du kan lave ' + d.tilbage + ' mere i dag.' : 'Vælg dit yndlingsportræt.');
      }).catch(function (e) {
        status(e.message === 'Failed to fetch' ? 'Ingen forbindelse. Prøv igen.' : e.message, true);
      }).then(function () {
        clearInterval(timer);
        s.travl = false; root.classList.remove('pw--travl'); opdater();
      });
    }

    function absolut(u) { return /^https?:/.test(u) ? u : api + u; }

    // Én generering = en række med portrætter. Nyeste øverst.
    function visGen(gen, nyeste) {
      var raekke = el('div', 'pw__gen');
      raekke.appendChild(el('div', 'pw__gen-titel', gen.stil + (gen.felter && gen.felter.navn ? ' · ' + gen.felter.navn : '')));
      var g = el('div', 'pw__gen-billeder');
      gen.billeder.forEach(function (b) {
        var knap = el('button', 'pw__res');
        knap.type = 'button';
        knap.dataset.id = b.id;
        var img = el('img'); img.src = b.url; img.alt = 'Portræt (forhåndsvisning)'; img.loading = 'lazy';
        img.onerror = function () { raekke.remove(); fjern(gen.id); };   // slettet på serveren
        knap.appendChild(img);
        knap.appendChild(el('span', 'pw__res-knap', 'Vælg dette'));
        knap.addEventListener('click', function () { vaelg(gen, b); });
        g.appendChild(knap);
      });
      raekke.appendChild(g);
      if (nyeste) ui.resultater.insertBefore(raekke, ui.resultater.firstChild); else ui.resultater.appendChild(raekke);
      opdater();
    }

    function fjern(genId) {
      s.liste = s.liste.filter(function (x) { return x.id !== genId; }); gem(emneId, s.liste);
      if (s.valgt && s.valgt.id.indexOf(genId) === 0) { s.valgt = null; saetSkjult(null); }
      opdater();
    }

    function vaelg(gen, b) {
      s.valgt = b;
      Array.prototype.forEach.call(root.querySelectorAll('.pw__res'), function (k) {
        var on = k.dataset.id === b.id;
        k.classList.toggle('pw__res--valgt', on);
        k.querySelector('.pw__res-knap').textContent = on ? '✓ Valgt' : 'Vælg dette';
      });
      saetSkjult(gen, b);
      root.classList.remove('pw--mangler');
      status('✓ Portræt valgt. Vælg størrelse, og læg plakaten i kurven.');
    }

    function saetSkjult(gen, b) {
      var v = { '_portraet_id': b && b.id, 'Portræt': b && b.url, 'Stil': gen && gen.stil };
      s.cfg.felter.forEach(function (f) { v[f.egenskab] = gen && gen.felter ? gen.felter[f.id] : ''; });
      Object.keys(ui.skjult).forEach(function (k) {
        ui.skjult[k].value = v[k] || '';
        ui.skjult[k].disabled = !v[k];   // tomme felter kommer ikke med på kurvlinjen
      });
    }

    // Spær "Læg i kurv", indtil et portræt er valgt. Vi lytter på window i capture-fasen, så vi kommer før temaets
    // egne lyttere: Horizon lytter selv på document og lagde ellers plakaten i kurven alligevel (fundet i test 25. okt.).
    function spaer(e) {
      e.preventDefault(); e.stopImmediatePropagation();
      root.classList.add('pw--mangler');
      if (s.cfg) status(s.liste.length ? 'Vælg et af portrætterne først.' : 'Lav og vælg dit portræt først.', true);
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    window.addEventListener('click', function (e) {
      var knap = e.target.closest && e.target.closest('button[type="submit"], input[type="submit"]');
      if (knap && knap.form === form && !s.valgt) spaer(e);
    }, true);
    window.addEventListener('submit', function (e) {
      if (e.target === form && !s.valgt) spaer(e);
    }, true);
  }

  function start() { Array.prototype.forEach.call(document.querySelectorAll('.pw[data-emne]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
